<template>
  <div class="loader-spinner"></div>
</template>

<style scoped>
@import "@/assets/base.css";
@import "@/assets/styles/animations.css";

.loader-spinner {
  border: 16px solid #f3f3f3;
  border-radius: 50%;
  border-top: 16px solid var(--clr-blue-1);
  width: 120px;
  height: 120px;
  -webkit-animation: loader-spin 2s linear infinite; /* Safari */
  animation: loader-spin 2s linear infinite;
  position: absolute;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  top: 40%;
  transform: translateY(-40%);
}
</style>
